module.exports = __webpack_public_path__ + "686595f530c35d3ceda71049d90fb2bc.svg";